import React from 'react';
import styled from 'App/styled';
import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';


interface Props {
  length: number;
}

const CardWrapper = styled.div`
  position: relative;
  height: 420px;
  padding: 10px;
  margin-bottom: 20px;
  width: 33.33%;
  min-width: 250px;
`;
const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0 1px 3px rgb(226 226 226 / 25%), 0 1px 2px rgb(226 226 226 / 50%);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
`;
const Image = styled(AnimatedLoader)`
  width: 100%;
  height: 215px;
  display: inline-block;
  margin-bottom: 10px;
`;

const DetailsWrapper = styled.div`
padding: 0 10px;
display: flex;
flex-direction: column;
align-items: center;
`;

const Line = styled(AnimatedLoader)`
  height: 7px;
  margin-bottom: 15px;
  width: 100%;
`;

const ListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`;

const getView = (count: number) => {
  const loader = [];
  for (let i = 0; i < count; i += 1) {
    loader.push(
      <CardWrapper key={`listing_loder_${i}`}>
        <Container>
          <Image className="client"/>
          <DetailsWrapper>
            <Line className="client"/>
            <Line className="client"/>
            <Line className="client"/>
            <Line className="client"/>
            <Line className="client"/>
          </DetailsWrapper>
        </Container>
      </CardWrapper>
    );
  }
  return loader;
};


export const ListingProductLoader = ({ length }: Props) => (
  <ListWrapper>
    {getView(length)}
  </ListWrapper>
);
